<template>
  <div>
    <el-dialog :visible.sync="showmodal" width="35%" @close="$emit('close-modal')">
      <div class="text-center modals-wrapper px-1">
        <img src="@/assets/images/icons/putonhold-finalmodal-icon.png" class=" mx-auto">
        <p class="mt-4 w-11/12 text-left">By confirming to put on-hold below, your assigned shipment would be put on
          hold. </p>
        <div class="mt-5 text-left">
          <p class="text-md">Please state the reason why?</p>
          <textarea class="rounded-sm w-full  p-3 border border-gray-100 block" rows="2"
            placeholder="Enter your reason(s)..." type="textarea" v-model="putonholdreason"></textarea>
        </div>
        <div class="flex flex-wrap justify-around items-center">
          <p @click="$emit('close-modal')"
            class="mt-12 rounded-md cursor-pointer p-3 w-1/2 text-left px-4 text-lg underline">Go back</p>
          <button v-loading="loading" @click="putOnHold" class="mt-12 rounded-md p-1 px-5 h-12"
            style="color:#10233E;">Confirm</button>

        </div>


      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dispatchId: {
      type: String,
      required: true
    },
    showmodal: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      putonholdreason: "",
    };
  },
  methods: {
    async putOnHold() {
      let request = {
        dispatchStatus: 'on-hold',
        message: this.putonholdreason,
        userId: this.$store.state.authentication.quantumUserId
      }

      try {
        this.loading = true

        await this.$_modifyDispatch(this.dispatchId, request)

        this.loading = false
        this.$emit('refetch-dispatch')
        this.$emit('close-modal')

      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    closeModal() {
      this.$emit("close-modal");
    }
  },
};
</script>

<style lang="scss" scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}

.modals-wrapper {
  button {
    background-color: #FCC210;
    color: #10233E;
    font-weight: 600;
  }
}
</style>
